import { Container, Sprite } from "@pixi/react";
import React from "react";
import { useSelector } from "react-redux";
import { ASSET_NAME } from "../../../../assets";
import * as PIXI from "pixi.js";
import { useDimensions } from "../../../../Contexts/DimensionsContext";
import { useToolbarDimensionsV2 } from "../../../../Hooks/useToolbarDimensionsV2";
import ButtonPlay from "../Buttons/ButtonPlay";
import ButtonHoldAndWinPlay from "../Buttons/ButtonHoldAndWinPlay";
import ButtonTurbo from "../Buttons/ButtonTurbo";
import ButtonAutoplay from "../Buttons/ButtonAutoplay";
import ButtonMaxBet from "../Buttons/ButtonMaxBet";
import ButtonBetSelect from "../Buttons/ButtonBetSelect";
import BalanceDisplay from "../Displays/BalanceDisplay";
import BetDisplay from "../Displays/BetDisplay";
import WinDisplay from "../Displays/WinDisplay";
import FreeRoundsWinDisplay from "../Displays/FreeRoundsWinDisplay";
import ButtonBonusBuy from "../Buttons/ButtonBonusBuy";
import { selectHoldAndWinActive } from "../../../../State/selectors";
import RespinsDisplay from "../../shared/Displays/RespinsDisplay";
import { FEATURES_CONFIG } from "../../../../featuresConfig";

const ToolbarBottom = () => {
  const texture = PIXI.Assets.get(ASSET_NAME.toolbar_gradient);
  const { dimensions } = useDimensions();

  // Get toolbar dimensions
  const toolbar = useToolbarDimensionsV2();

  // Check if HoldAndWin feature is active
  const holdAndWinActive = useSelector(selectHoldAndWinActive);

  return (
    <Container
      name="secondary_toolbar_bottom"
      x={(dimensions.width - toolbar.width) / 2}
      y={dimensions.height - toolbar.height}
    >
      {/* Background */}
      <Sprite height={toolbar.height} texture={texture} width={toolbar.width} />

      <BalanceDisplay toolbar={toolbar} />
      <BetDisplay toolbar={toolbar} />
      <ButtonAutoplay toolbar={toolbar} />
      {FEATURES_CONFIG.BONUS_BUY.ENABLED && <ButtonBonusBuy toolbar={toolbar} />}
      {FEATURES_CONFIG.HOLD_AND_WIN.ENABLED && holdAndWinActive ? (
        <>
          <RespinsDisplay toolbar={toolbar} />
          <ButtonHoldAndWinPlay toolbar={toolbar} />
        </>
      ) : (
        <ButtonPlay toolbar={toolbar} />
      )}
      <ButtonTurbo toolbar={toolbar} />
      <ButtonMaxBet toolbar={toolbar} />
      <ButtonBetSelect toolbar={toolbar} />
      <WinDisplay toolbar={toolbar} />
      {FEATURES_CONFIG.FREE_ROUNDS.ENABLED && <FreeRoundsWinDisplay toolbar={toolbar} />}
    </Container>
  );
};

export default ToolbarBottom;
